import React from "react";

// Port code to country code mapping (extend as needed)
const PORT_COUNTRY_MAP = {
    // United States
    USORF: "US", USCHI: "US", USLAX: "US", USNYC: "US", USSEA: "US", USHOU: "US",
    USMIA: "US", USSAV: "US", USBAL: "US", USBOS: "US", USJAX: "US", USPHL: "US",
    // India
    INNSA: "IN", INMUN: "IN", INMAA: "IN", INBOM: "IN", INCCU: "IN",
    // China
    CNSHA: "CN", CNNGB: "CN", CNSZX: "CN", CNTAO: "CN", CNXMN: "CN", CNDAL: "CN",
    // Singapore
    SGSIN: "SG",
    // UAE
    AEDXB: "AE", AEJEA: "AE", AEAUH: "AE",
    // UK
    GBFXT: "GB", GBLIV: "GB", GBSOU: "GB", GBTIL: "GB",
    // Netherlands
    NLRTM: "NL", NLAMS: "NL",
    // Germany
    DEHAM: "DE", DEBREM: "DE",
    // France
    FRLEH: "FR", FRFOS: "FR",
    // Japan
    JPYOK: "JP", JPTYO: "JP", JPKOB: "JP",
    // South Korea
    KRPUS: "KR", KRINC: "KR",
    // Australia
    AUSYD: "AU", AUMEL: "AU", AUBNE: "AU",
    // Canada
    CAVAN: "CA", CATOR: "CA", CAMTR: "CA",
    // Brazil
    BRSSZ: "BR", BRRIG: "BR",
    // Mexico
    MXZLO: "MX", MXVER: "MX",
    // Spain
    ESVLC: "ES", ESBCN: "ES",
    // Italy
    ITGOA: "IT", ITGIT: "IT",
    // Belgium
    BEANR: "BE",
    // Saudi Arabia
    SAJED: "SA", SADMM: "SA",
};

// Get country code from port code
const getCountryCode = (portCode) => {
    if (!portCode || typeof portCode !== "string") return null;
    const code = portCode.trim().toUpperCase();
    return PORT_COUNTRY_MAP[code] || code.slice(0, 2);
};

// Country flag image URL using flagcdn
const getFlagUrl = (countryCode) => {
    if (!countryCode) return null;
    return `https://flagcdn.com/24x18/${countryCode.toLowerCase()}.png`;
};

// Country Flag Component with box styling - no border
const CountryFlagBox = ({ countryCode, type }) => {
    if (!countryCode) return null;

    return (
        <div className="flex items-center gap-1.5 rounded px-1.5 py-0.5 bg-slate-100 dark:bg-slate-700">
            <img
                src={getFlagUrl(countryCode)}
                alt={countryCode}
                className="w-5 h-4 object-cover rounded-sm"
                onError={(e) => {
                    e.target.style.display = 'none';
                }}
            />
            <span className="text-xs font-bold text-slate-700 dark:text-slate-300">
                {countryCode}
            </span>
        </div>
    );
};

// Main PortBadge Component
const PortBadge = ({ port, code, type, showCountryBox = true }) => {
    const countryCode = getCountryCode(code);

    return (
        <div className="flex items-center gap-2">
            {/* Country Flag Box */}
            {showCountryBox && countryCode && (
                <CountryFlagBox countryCode={countryCode} type={type} />
            )}

            {/* Port Info */}
            <div className="flex flex-col">
                <span className="text-sm font-semibold text-slate-900 dark:text-white">
                    {port || "N/A"}
                </span>
                {code && (
                    <span
                        className={`text-xs font-mono ${type === "pol"
                                ? "text-blue-600 dark:text-blue-400"
                                : "text-emerald-600 dark:text-emerald-400"
                            }`}
                    >
                        [{code}]
                    </span>
                )}
            </div>
        </div>
    );
};

// Export both for flexibility
export { CountryFlagBox, getCountryCode, getFlagUrl };
export default PortBadge;
